import React, { useEffect } from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { RBACProvider } from "./contexts/RBACContext";
import { BookingProvider } from "./contexts/BookingContext";
import { ClaimsProvider } from "./contexts/ClaimsContext";
import { RealtimeProvider } from "./contexts/RealtimeContext";

// Clear any cached resident/stay data from previous sessions
const RESIDENT_CACHE_KEYS = [
  'stays', 'residents', 'bookingStays', 'reservations', 'checkIns',
  'checkOuts', 'occupancy', 'mealTickets', 'restaurantLogs', 'claims',
  'roomAssignments', 'demoData', 'sampleData', 'mockData',
];
RESIDENT_CACHE_KEYS?.forEach(key => {
  try { localStorage.removeItem(key); } catch (_) {}
  try { sessionStorage.removeItem(key); } catch (_) {}
});

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <RBACProvider>
          <BookingProvider>
            <RealtimeProvider>
              <ClaimsProvider>
                <NotificationProvider>
                  <Routes />
                </NotificationProvider>
              </ClaimsProvider>
            </RealtimeProvider>
          </BookingProvider>
        </RBACProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
